// removed by extract-text-webpack-plugin
module.exports = {"listItem":"CartItemsMobileList__listItem___qAOEG","itemsDivider":"CartItemsMobileList__itemsDivider___2911F","title":"CartItemsMobileList__title___2MpmW","description":"CartItemsMobileList__description___2_OPY"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Cart/elements/CartItemsMobileList.scss
 ** module id = 1224
 ** module chunks = 0
 **/